// extracted by mini-css-extract-plugin
module.exports = {"button":"rSZwFE4_HNsxd-SPRGrJd primaryBackgroundColor buttonShadow","title":"y7kq7LE-dMMqsysnh2_bC"};